import { Get } from "../components/Post";
import { Head, Banner, Contact } from "../components/Project";
import { Grid, Space, Table } from "../components/Layout";
import { Title, Texts, Media, Button, ScrollTop } from "../components/Object";
import { NewsList, Pagination, SetDate, SetImg } from "../components/Post";
import { useParams } from "react-router-dom";
import { useDocumentLoadCompleted } from "../components/Hooks";

const Post = (props) => {
  const parms = useParams();

  const args = {
    postType: props.postType,
    type: props.type,
    id: parms.postId,
  };

  const isLoaded = useDocumentLoadCompleted();

  const posts = Get(args);

  return (
    <>
      {posts && (
        <>
          <Head slug={props.postType}></Head>
          <Space size={['0 0 64px', '0 0 48px']}>
            <div className="l-row" data-state="min">
              {/* title */}
              <p
                className="c-text__title-middle-24"
                dangerouslySetInnerHTML={{ __html: posts.title.rendered }}
              ></p>
              <Space size={['32px auto 40px', '24px auto 32px']}>
                {/* date */}
                <p className="c-text--en c-text__min c-text--bold c-text--opacity5">
                  { SetDate(posts.date) }
                </p>
              </Space>
              <img className='p-img__post' src={SetImg(posts)} alt="media" />
              <div
                dangerouslySetInnerHTML={{ __html: posts.content.rendered}}
                className="c-text__normal p-post__wrap--body" >
              </div>
            </div>
          </Space>
          
          <div className="l-row">
            <Button type="main-center" link={`/${props.postType}`} slug="return"></Button>
          </div>
        
          <ScrollTop></ScrollTop>

        </>
      )}
    </>
  );
};

export default Post;
